const theme = [
  {
    id: "sentinel",
    hostnames: [],
    name: "Sentinel",
    title: "Sentinel Partner Platform",
    path: "sentinel",
    dark: {
      primary: "#32a5c4",
      secondary: "#1f7f98",
      accent: "#8c9eff",
      error: "#b71c1c",
    },
    light: {
      primary: "#32a5c4",
      secondary: "#1f7f98",
      accent: "#8c9eff",
      error: "#b71c1c",
    },
    colorVariables: {
      primary: "#32a5c4",
      secondary: "#1f7f98",
      navigationBarBackgroundColor: "rgba(0, 0, 0, 0.1)",
      navigationBarColor: "#000000",
    },
  },
  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    title: "SEANAPPS Partner Platform",
    path: "beneteau",
    dark: {
      primary: "#00006e",
      secondary: "#0087ff",
      accent: "#7CB342",
      success: "#4CAF50",
      info: "#6156d8",
      warning: "#1565C0",
      error: "#FF7043",
    },
    light: {
      primary: "#00006e",
      secondary: "#0087ff",
      accent: "#7CB342",
      success: "#4CAF50",
      info: "#6156d8",
      warning: "#1565C0",
      error: "#FF7043",
    },
    colorVariables: {
      primary: "#00006e",
      secondary: "#0087ff",
      navigationBarBackgroundColor: "#0087ff",
      navigationBarColor: "white",
    },
  },
];

const logo = [
  {
    id: "sentinel",
    hostnames: [],
    name: "Sentinel",
    path: "sentinel",
  },
  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    path: "beneteau",
  },
];

const clientIDs = [
  {
    hostnames: [],
    name: "Sentinel",
    id: "sentinel",
    clientId: "726b8d323a4662ad4023",
    clientSecret: "8954262e0e67556b1db20a502bbdb98de01f2215",
  },
  {
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    id: "beneteau",
    clientId: "327acee46813510051d0",
    clientSecret: "52265a8f6eae098ad65f07a723d089b6cb607f3a",
  },
];

const links = [
  {
    id: "sentinel",
    hostnames: [],
    name: "Sentinel",
    privacyPolicy: "https://www.sentinelmarine.net/mobile/privacy-policy",
    termsOfUse: "https://www.sentinelmarine.net/mobile/terms-of-use",
    termsAndConditions:
      "https://app.sentinelmarine.net/api/v2/documents/partner-tac/",
    legalNotice: false,
    supportEmail: "support@sentinelmarine.net",
  },
  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    privacyPolicy: "https://web-docs.seanapps.app/pp-dealers.html",
    termsOfUse: "https://web-docs.seanapps.app/tac-dealers.html",
    legalNotice: "https://www.seanapps.fr/en/legal-notice/",
    supportEmail: "contact@seanapps.fr",
  },
];

const analyticsConfig = [
  {
    id: "sentinel",
    hostnames: [],
    ga: {
      config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_SENTINEL },
      appName: "Partner Platform Sentinel",
      pageTrackerScreenviewEnabled: true,
    },
    hotjar: null,
  },

  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    ga: {
      config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_SEANAPPS },
      appName: "Partner Platform Seanapps",
      pageTrackerScreenviewEnabled: true,
    },
    hotjar: {
      id: "3390905",
      isProduction: true,
    },
  },
];

const defaultTheme = theme.find((element) => element.id === "sentinel");
const defaultLogo = logo.find((element) => element.id === "sentinel");
const defaultClientIDs = clientIDs.find((element) => element.id === "sentinel");
const defaultLinks = links.find((element) => element.id === "sentinel");
const defaultAnalytics = analyticsConfig.find(
  (element) => element.id === "sentinel"
);

export default {
  theme,
  defaultTheme,
  logo,
  defaultLogo,
  clientIDs,
  defaultClientIDs,
  links,
  defaultLinks,
  analyticsConfig,
  defaultAnalytics,
};
